import { render, staticRenderFns } from "./RatingPCC.vue?vue&type=template&id=b52ab83a&"
import script from "./RatingPCC.vue?vue&type=script&lang=js&"
export * from "./RatingPCC.vue?vue&type=script&lang=js&"
import style0 from "./RatingPCC.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RatingPCC.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports